import React, { useState } from 'react';
import {
  FaPlay, FaImages, FaCalendar, FaUser, FaExternalLinkAlt,
  FaFileAlt, FaGraduationCap, FaArrowRight, FaSlidersH
} from 'react-icons/fa';
import './Portfolio.css';

/* ── Data ──────────────────────────────────────────────────────────────── */

const CATEGORIES = [
  'ALL', 'VISUAL & PERFORMING ARTS', 'RESEARCH & TECHNOLOGY', 'DESIGN & GAMES',
  /*'TEACHING & COACHING', */'HOBBIES & INTERESTS',
];

const PROJECTS = {
  circus: {
    id: 'circus',
    title: 'Circus / Partner Acrobatics',
    description: 'A collection of performances, teaching, and movement exploration.',
    categories: ['VISUAL & PERFORMING ARTS', 'TEACHING & COACHING'],
    type: 'multifaceted',
  },
  neuroscience: {
    id: 'neuroscience',
    title: 'Neuroscience',
    description: 'Exploring the brain and human behavior through research and analysis.',
    categories: ['RESEARCH & TECHNOLOGY'],
    type: 'medium',
  },
  modeling: {
    id: 'modeling',
    title: 'Modeling & Visual Expressions',
    description: 'Paintings, portraits, and other creative photographic work.',
    categories: ['VISUAL & PERFORMING ARTS'],
    type: 'multiple',
  },
  gamedesign: {
    id: 'gamedesign',
    title: 'Game Design',
    description: 'Board games, card games, and interactive experiences.',
    categories: ['DESIGN & GAMES', 'VISUAL & PERFORMING ARTS', 'HOBBIES & INTERESTS'],
    type: 'multiple',
  },
  google: {
    id: 'google',
    title: 'Google Career',
    description: 'Software engineer and UX engineer 2011-2021',
    categories: ['RESEARCH & TECHNOLOGY'],
    type: 'small',
    image: './img/project-imgs/google.jpg',
    href: '/cv.html#google',
  },
  academic: {
    id: 'academic',
    title: 'Academics',
    description: 'Degrees in Neuroscience, Creative Writing, Computer Science, and Multilingual Studies.',
    categories: ['RESEARCH & TECHNOLOGY'],
    type: 'small',
    image: './img/project-imgs/academic.jpg',
    href: '/cv.html#edu',
  },
  illustrations: {
    id: 'illustrations',
    title: 'Illustrations',
    description: 'Digital illustrations and sketches.',
    categories: ['VISUAL & PERFORMING ARTS', 'HOBBIES & INTERESTS'],
    type: 'small',
    image: './img/project-imgs/illustration.png',
    href: 'https://drive.google.com/drive/folders/1YRjTVnAqyNezzqpXEcGC4ea7dtJfSeCi',
  },
  cooking: {
    id: 'cooking',
    title: 'Culinary Projects',
    description: 'Constantly cooking up something unusual',
    categories: ['HOBBIES & INTERESTS'],
    type: 'small',
    image: './img/project-imgs/food.jpg',
    href: 'https://photos.app.goo.gl/cNJ8bAhFbmmK6fdM6',
  },
/*  chinese: {
    id: 'chinese',
    title: 'Learning Chinese',
    description: "It doesn't make for great photos, but learning spoken Mandarin Chinese has taken the largest portion of my hobby time of late.",
    categories: ['HOBBIES & INTERESTS', 'WRITING & CULTURE'],
    type: 'small',
    image: './img/project-imgs/chinese.jpg',
    href: null, // no link
  },*/
  others: {
    id: 'possibilities-others',
    title: 'Possibilities for Others',
    description: "Always exploring what's next.",
    categories: [],
    type: 'placeholder',
  },
};

/* ── Component ──────────────────────────────────────────────────────────── */

const Portfolio = () => {
  const [activeCategory, setActiveCategory] = useState('ALL');

  const isVisible = (project) => {
    if (activeCategory === 'ALL') return true;
    console.log(project.id, project.categories, project.categories.includes(activeCategory));
    return project.categories.includes(activeCategory);
  };

  return (
    <div className="portfolio-page" id="portfolio">

      {/* ── Page Header ── */}
      {/*<div className="portfolio-header">
        <h1 className="portfolio-title">Portfolio</h1>
        <p className="portfolio-subtitle">A curated compendium of work, explorations, and experiences.</p>
      </div>*/}

      <br/>
      {/* ── Filter Nav ── */}
      <nav className="portfolio-filter-nav">
        <div className="filter-tabs">
          {CATEGORIES.map(cat => (
            <button
              key={cat}
              className={`filter-tab ${activeCategory === cat ? 'active' : ''}`}
              onClick={() => setActiveCategory(cat)}
            >
              {cat}
            </button>
          ))}
        </div>
        <button className="filter-button"><FaSlidersH /> FILTER</button>
      </nav>

      {/* ── Main Grid ── */}
      <div className="portfolio-grid">

        {/* ── Row 1: Circus (left) + Neuroscience (right) ── */}
        {(isVisible(PROJECTS['circus']) || isVisible(PROJECTS['neuroscience'])) && (
          <div className="portfolio-row row-split">

            {isVisible(PROJECTS['circus']) && (
              <div className="card card-multifaceted">
                <div className="card-hero-img-wrap">
                  <img src="./img/project-imgs/acro.png" alt="Partner acrobatics" className="card-hero-img" />
                </div>
                <div className="card-thumb-strip">
                  <div className="card-thumb"><img src="./img/project-imgs/circus-1.jpg" alt="Circus performances" /></div>
                  <div className="card-thumb"><img src="./img/project-imgs/circus-2.jpg"   alt="Acrobatics" /></div>
                  <div className="card-thumb"><img src="./img/project-imgs/circus-3.png" alt="Circus 2" /></div>
                  <div className="card-thumb"><img src="./img/project-imgs/circus-4.png"   alt="Acrobatics 2" /></div>
                </div>
                <div className="card-body">
                  <h3 className="card-title">Circus / Partner Acrobatics</h3>
                  <p className="card-desc">A collection of performances, teaching, and movement exploration.</p>
                  <div className="card-links">
                    <a href="http://www.guns-n-poses.idamayer.com/demo-reel.html"
                       className="card-link" target="_blank" rel="noopener noreferrer">
                      <FaPlay /><span>Demo Reel</span>
                    </a>
                    <a href="http://www.guns-n-poses.idamayer.com/gallery.html"
                       className="card-link" target="_blank" rel="noopener noreferrer">
                      <FaImages /><span>Photo Gallery</span>
                    </a>
                    <a href="/cv.html#acro" className="card-link">
                      <FaCalendar /><span>Performances</span>
                    </a>
                    <a href="/classes.html" className="card-link">
                      <FaExternalLinkAlt /><span>Online Classes</span>
                    </a>
                  </div>
                </div>
              </div>
            )}

            {isVisible(PROJECTS['neuroscience']) && (
              <div className="card card-medium">
                {/* Top row: title/desc left, hero image right */}
                <div className="card-neuro-top">
                  <div className="card-neuro-text">
                    <h3 className="card-title">Neuroscience</h3>
                    <p className="card-desc">Exploring the brain and human behavior through research and analysis.</p>
                  </div>
                  <div className="card-neuro-hero">
                    <img src="./img/project-imgs/neuro-hero.png" alt="Neuroscience research" />
                  </div>
                </div>

                {/* Two paper doc thumbnails side by side */}
                <div className="card-neuro-docs">
                  <div className="card-doc">
                    <img src="./img/project-imgs/neuro.png" alt="Published paper" />
                  </div>
                  <div className="card-doc">
                    <img src="./img/project-imgs/thesis.jpg" alt="Master's thesis" />
                  </div>
                </div>

                {/* Links aligned under their respective docs, arrow at far right */}
                <div className="card-neuro-footer">
                  <a href="https://www.nature.com/articles/s42003-023-05199-x"
                     className="card-link" target="_blank" rel="noopener noreferrer">
                    <FaFileAlt /><span>Nature Communications</span>
                  </a>
                  <a href="https://docs.google.com/presentation/d/1zt8b2YIOJFXeiIoCm52bD5wF4fiSME-pFo65GBBDv3M/edit?usp=sharing"
                     className="card-link" target="_blank" rel="noopener noreferrer">
                    <FaGraduationCap /><span>Master's Thesis</span>
                  </a>
                </div>
                <div className="card-arrow-wrap"><a href="/cv.html#neuro" className="card-arrow-btn"><FaArrowRight /></a></div>
              </div>
            )}

          </div>
        )}

        {/* ── Row 2: Modeling (left) + Game Design (right) ── */}
        {(isVisible(PROJECTS['gamedesign']) || isVisible(PROJECTS['modeling'])) && (
          <div className="portfolio-row row-split">

            {isVisible(PROJECTS['modeling']) && (
              <div className="card card-multiple">
                <div className="card-body card-body-top">
                  <h3 className="card-title">Modeling &amp;<br />Visual Expressions</h3>
                  <p className="card-desc">I've been a freelance model for over 10 years, with paintings of me shown internationally and sold for upwards of $14k.</p>
                </div>
                <div className="card-thumb-strip card-thumb-strip--4">
                  <div className="card-thumb"><img src="./img/project-imgs/asencio.jpg"     alt="Henry Asencio painting" /></div>
                  <div className="card-thumb"><img src="./img/project-imgs/nude.jpg"         alt="Creative portrait" /></div>
                  <div className="card-thumb"><img src="./img/project-imgs/valleyoffire.png" alt="Valley of Fire" /></div>
                  <div className="card-thumb"><img src="./img/project-imgs/sfevans.png"         alt="Portfolio portrait" /></div>
                </div>
                <div className="card-body">
                  <div className="card-links">
                    <a href="https://artworldmatch.com/art/aerial-by-henry-asencio"
                       className="card-link" target="_blank" rel="noopener noreferrer">
                      <FaImages /><span>Henry Asencio Paintings</span>
                    </a>
                    <a href="https://www.instagram.com/p/CYKHh7DptFw/"
                       className="card-link" target="_blank" rel="noopener noreferrer">
                      <FaImages /><span>Valley of Fire Project</span>
                    </a>
                    <a href="https://instagram.com/idamayeraesthetic"
                       className="card-link" target="_blank" rel="noopener noreferrer">
                      <FaUser /><span>Portraits / Portfolio</span>
                    </a>
                  </div>
                  <a href="https://www.modelmayhem.com/idamayer"
                     className="card-arrow-btn" target="_blank" rel="noopener noreferrer">
                    <FaArrowRight />
                  </a>
                </div>
              </div>
            )}

            {isVisible(PROJECTS['gamedesign']) && (
              <div className="card card-multiple">
                {/* Top row: title/desc left, hero image right */}
                <div className="card-games-top">
                  <div className="card-games-text">
                    <h3 className="card-title">Game Design</h3>
                    <p className="card-desc">Board games, card games, and interactive experiences.</p>
                  </div>
                  <div className="card-games-hero">
                    <img src="./img/project-imgs/games-hero.png" alt="Modern Games Deck" />
                  </div>
                </div>

                {/* Bottom row: 3 equal thumbnails */}
                <div className="card-games-thumbs">
                  <div className="card-game-thumb"><a href="https://idamayer.com/moderngamesdeck/"><img src="./img/project-imgs/cards.jpg" alt="Modern Games Deck" /></a></div>
                  <div className="card-game-thumb"><a href="https://zathewordgame.wordpress.com/"><img src="./img/project-imgs/za.png"    alt="Za: The Word Game" /></a></div>
                  <div className="card-game-thumb"><a href="https://idamayer.com/hanabi"><img src="./img/project-imgs/hanabi.png" alt="Hanabi Reskin" /></a></div>
                </div>

                {/* Labels aligned under their respective thumbnails, arrow at far right */}
                <div className="card-games-footer">
                  <a href="https://idamayer.com/moderngamesdeck/"
                     className="card-game-label" target="_blank" rel="noopener noreferrer">
                    Modern Games Deck
                  </a>
                  <a href="https://zathewordgame.wordpress.com/"
                     className="card-game-label" target="_blank" rel="noopener noreferrer">
                    Za: The Word Game
                  </a>
                  <a href="https://idamayer.com/hanabi"
                    className="card-game-label" target="_blank" rel="noopener noreferrer">Hanabi Reskin</a>
                  {/*<a 
                     className="card-arrow-btn" target="_blank" rel="noopener noreferrer">
                    <FaArrowRight />
                  </a> */}
                </div>
              </div>
            )}

          </div>
        )}

        {/* ── Row 3: Google · Academic · Illustrations · Culinary ── */}
        <div className="portfolio-row row-quad">
          {['google', 'academic', 'illustrations', 'cooking'].map(id => {
            const p = PROJECTS[id];
            if (!isVisible(p)) return null;
            const Inner = (
              <>
                <div className="card-body card-body-top">
                  <h3 className="card-title">{p.title}</h3>
                  <p className="card-desc">{p.description}</p>
                </div>
                <div className="card-small-img">
                  <img src={p.image} alt={p.title} />
                </div>
                <div className="card-arrow-wrap">
                  <span className="card-arrow-btn"><FaArrowRight /></span>
                </div>
              </>
            );
            return p.href
              ? <a key={id} href={p.href} className="card card-small" target={p.href.startsWith('http') ? '_blank' : undefined} rel="noopener noreferrer">{Inner}</a>
              : <div key={id} className="card card-small card-no-link">{Inner}</div>;
          })}
        </div>

        {/* ── Row 4: Chinese · (empty) · (empty) · Possibilities ── */}
        {/*<div className="portfolio-row row-quad">
          {(() => {
            const p = PROJECTS['chinese'];
            if (!isVisible(p)) return null;
            return (
              <div className="card card-small card-no-link">
                <div className="card-body card-body-top">
                  <h3 className="card-title">{p.title}</h3>
                  <p className="card-desc">{p.description}</p>
                </div>
                <div className="card-small-img">
                  <img src={p.image} alt={p.title} />
                </div>
              </div>
            );
          })()}
          <div className="card card-empty" />
          <div className="card card-empty" />
          <div className="card card-placeholder">
            <FaPlus className="placeholder-plus" />
            <h3 className="card-title">Possibilities<br />for Others</h3>
            <p className="card-desc">Always exploring what's next. Get in touch if you'd like to collaborate.</p>
          </div>
        </div> */}

      </div>{/* /portfolio-grid */}

      <br/>

    </div>
  );
};

export default Portfolio;
